import {ActionTypes, strings} from './../../cc-imports'
import {Constants} from "../../config";


const Actions = {
    openHome: ()=> {
        return {
            type: ActionTypes.HOME,
        }
    },
    openLeagues: (matchId)=> {
        return {
            type: ActionTypes.LEAGUES,
            payload : {
                matchId : matchId
            }
        }
    },
    goBack:() =>{
        return {
            type: ActionTypes.BACK
        }
    },



    openAddCoinsModal : ()=> {
        return ({
            type: ActionTypes.OPEN_MODAL,
            payload : {
                name : "AddCoinsModal"
            }
        })
        /*return (dispatch)=>{
            dispatch({
                type : ActionTypes.PRE_CLOSE_MODAL
            });
            setTimeout(() => {
                dispatch({
                    type: ActionTypes.OPEN_MODAL,
                    payload : {
                        name : 'AddCoins'
                    }
                })
            }, 1000)
        }*/
    },
    openSingleLeagueModal : (league)=> {
        return ({
            type: ActionTypes.OPEN_MODAL,
            payload : {
                league : league,
                name : 'SingleLeagueModal'
            }
        })
        /*return (dispatch)=>{
            dispatch({
                type : ActionTypes.PRE_CLOSE_MODAL
            })
            setTimeout(() => {
                dispatch({
                    type: ActionTypes.OPEN_MODAL,
                    payload : {
                        league : league,
                        name : 'SingleLeagueModal'
                    }
                })
            }, 1000)
        }*/
    },
    openReAuthModal : (payload)=> {
        return ({
            type: ActionTypes.OPEN_MODAL,
            payload : {
                ...payload,
                name : 'ReAuth'
            }
        })
       /* return (dispatch)=>{
            dispatch({
                type : ActionTypes.PRE_CLOSE_MODAL
            })
            setTimeout(() => {
                dispatch({
                    type: ActionTypes.OPEN_MODAL,
                    payload : {
                        ...payload,
                        name : 'ReAuth'
                    }
                })
            }, 1000)
        }*/
    },
    openSignInModal : (payload)=> {
        return ({
            type: ActionTypes.OPEN_MODAL,
            payload : {
                ...payload,
                name : 'SignIn'
            }
        })
        /*return (dispatch)=>{
            dispatch({
                type : ActionTypes.PRE_CLOSE_MODAL
            })
            setTimeout(() => {
                dispatch({
                    type: ActionTypes.OPEN_MODAL,
                    payload : {
                        ...payload,
                        name : 'SignIn'
                    }
                })
            }, 1000)
        }*/
    },
    openEntriesModal : ()=>{
        return({
            type: ActionTypes.OPEN_MODAL,
            payload : {
                name : 'Entries'
            }
        })
        /*return (dispatch)=>{
            dispatch({
                type : ActionTypes.PRE_CLOSE_MODAL
            })
            setTimeout(() => {
                dispatch({
                    type: ActionTypes.OPEN_MODAL,
                    payload : {
                        name : 'Entries'
                    }
                })
            }, 1000)
        }*/
    },
    openNotificationsModal : ()=> {

        return({
            type: ActionTypes.OPEN_MODAL,
            payload : {
                name : 'Notifications'
            }
        })
        /*return (dispatch)=>{
            dispatch({
                type : ActionTypes.PRE_CLOSE_MODAL
            })
            setTimeout(() => {
                dispatch({
                    type: ActionTypes.OPEN_MODAL,
                    payload : {
                        name : 'Notifications'
                    }
                })
            }, 1000)
        }*/
    },
    openChatModal : ()=> {
        return({
            type: ActionTypes.OPEN_MODAL,
            payload : {
                name : 'Chats'
            }
        })
        /*return (dispatch)=>{
            dispatch({
                type : ActionTypes.PRE_CLOSE_MODAL
            })
            setTimeout(() => {
                dispatch({
                    type: ActionTypes.OPEN_MODAL,
                    payload : {
                        name : 'Chats'
                    }
                })
            }, 1000)
        }*/
    },
    openMoreModal : ()=> {
        return({
            type: ActionTypes.OPEN_MODAL,
            payload : {
                name : 'More'
            }
        })
    },
    openTransactionsHistoryModal : ()=> {
        return({
            type: ActionTypes.OPEN_MODAL,
            payload : {
                name : 'TransactionsHistory'
            }
        })
        /*return (dispatch)=>{
            dispatch({
                type : ActionTypes.PRE_CLOSE_MODAL
            })
            setTimeout(() => {
                dispatch({
                    type: ActionTypes.OPEN_MODAL,
                    payload : {
                        name : 'TransactionsHistory'
                    }
                })
            }, 1000)
        }*/
    },
    openDreamTeamEntryCreationModal : (league)=> {
        return({
            type: ActionTypes.OPEN_MODAL,
            payload : {
                name : 'DreamTeamEntryCreation',
                league : league
            }
        })
        /*return (dispatch)=>{
            dispatch({
                type : ActionTypes.PRE_CLOSE_MODAL
            })
            setTimeout(() => {
                dispatch( {
                    type: ActionTypes.OPEN_MODAL,
                    payload : {
                        name : 'DreamTeamEntryCreationModal',
                        league : league
                    }
                })
            }, 1000)
        }*/
    },
    openPredictionEntryCreationModal : (league)=> {
        return( {
            type: ActionTypes.OPEN_MODAL,
            payload : {
                name : 'PredictionEntryCreation',
                league : league
            }
        })
       /* return (dispatch)=>{
            dispatch({
                type : ActionTypes.PRE_CLOSE_MODAL
            })
            setTimeout(() => {
                dispatch(  {
                    type: ActionTypes.OPEN_MODAL,
                    payload : {
                        name : 'PredictionEntryCreationModal',
                        league : league
                    }
                })
            }, 1000)
        }*/
    },
    openSponsorDetailsModal : (sponsor)=> {
        return({
            type: ActionTypes.OPEN_MODAL,
            payload : {
                name : 'SponsorDetails',
                sponsor : sponsor
            }
        })
    },
    closeModal : (name)=>{
        return( {
            type: ActionTypes.CLOSE_MODAL,
            payload: {
                name : name
            }
        });
        /*return (dispatch)=>{
            dispatch({
                type: ActionTypes.CLOSE_MODAL,
                payload: {
                    name : name
                }
            })
            setTimeout(() => {
                dispatch(  {
                    type: ActionTypes.OPEN_LAST_OPEN_MODAL
                })
            }, 1000)
        }*/
    },



    showEmailNotVerifiedMessage:(callback)=>{
        return {
            type: ActionTypes.SHOW_ALERT,
            payload: {
                name : 'EmailNotVerified',
                message : strings('email_not_verified') +' '+ strings('email_not_verified_to_claim_rewards'),
                clickableMessage : ' '+ strings('click_here_to_resend'),
                type : 'WARNING',
                textLines : 2,
                buttonAction : callback
            }
        }
    },

    hideEmailNotVerifiedMessage:()=>{
        return {
            type: ActionTypes.HIDE_ALERT,
            payload: {
                name : 'EmailNotVerified',
            }
        }
    },


    showNoNetworkMessage:()=>{
        return {
            type: ActionTypes.SHOW_ALERT,
            payload: {
                name : 'NoNetwork',
                message : strings('no_network_connection'),
                type : 'INFO'
            }
        }
    },

    hideNoNetworkMessage:()=>{
        return {
            type: ActionTypes.HIDE_ALERT,
            payload: {
                name : 'NoNetwork',
            }
        }
    }
};

export default Actions



// WEBPACK FOOTER //
// ./src/app/data/actions/NavigationActions.js